import PropTypes from 'prop-types';

export const SidebarPropTypes = {
    filters: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            options: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string.isRequired,
                    value: PropTypes.string.isRequired,
                    count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
                    checked: PropTypes.bool,
                    type: PropTypes.string
                })
            ).isRequired
        })
    ).isRequired,
    onFilterChange: PropTypes.func.isRequired,
    title: PropTypes.string,
    columnSize: PropTypes.string
};
